import { render, staticRenderFns } from "./Events.vue?vue&type=template&id=3bf2e0e4&"
import script from "./Events.vue?vue&type=script&lang=js&"
export * from "./Events.vue?vue&type=script&lang=js&"
import style0 from "./Events.vue?vue&type=style&index=0&id=3bf2e0e4&prod&lang=scss&"
import style1 from "./Events.vue?vue&type=style&index=1&id=3bf2e0e4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports